import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BxSpinnerModule } from '@buildxact/ui-components/bx-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { UiSwitchModule } from 'ngx-ui-switch';
import { BxNoticesModule } from '../bx-notices/bx-notices.module';
import { BxGlobalNotificationsComponent } from './bx-global-notifications.component';
import { BxNotificationsResultsPanelComponent } from './bx-notifications-results-panel/bx-notifications-results-panel.component';

@NgModule({
    declarations: [BxGlobalNotificationsComponent, BxNotificationsResultsPanelComponent],
    imports: [CommonModule, BxSpinnerModule, BxNoticesModule, TranslateModule.forChild({}), UiSwitchModule],
    exports: [BxGlobalNotificationsComponent],
})
export class BxGlobalNotificationsModule {}
